import React, { useState, useEffect } from 'react';
import { Inbox, MapPin, Clock, Phone, AlertTriangle } from 'lucide-react';
import { saasApi } from '../../api/client';

export const InboxTab = () => {
  const [convs, setConvs] = useState(null);

  useEffect(() => { saasApi.inbox().then(setConvs).catch(() => setConvs([])); }, []);

  if (convs === null) return <div className="text-[#52676e] text-sm py-8 text-center">Carregando inbox...</div>;

  if (convs.length === 0) return (
    <div className="bg-white border border-[#cbd8dc] rounded-[10px] p-10 text-center" data-testid="inbox-empty">
      <Inbox className="w-10 h-10 text-[#6b858e] mx-auto mb-3" />
      <h3 className="font-semibold text-[#153e44]">Nenhum atendimento recebido</h3>
      <p className="text-sm text-[#52676e] mt-1">Quando um cliente concluir a triagem com a recepcionista digital e autorizar o envio, o atendimento aparecerá aqui.</p>
    </div>
  );

  return (
    <div className="space-y-3" data-testid="inbox-list">
      {convs.map(c => {
        const col = c.collected || {};
        const urgent = (col.urgencia || '').toLowerCase().includes('alta') || (col.urgencia || '').toLowerCase().includes('urgente');
        return (
          <div key={c.id} className="bg-white border border-[#cbd8dc] rounded-[10px] p-5" data-testid={`inbox-item-${c.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <div className="font-semibold text-[#153e44]">{col.nome || 'Sem nome'} <span className="text-xs font-normal text-[#52676e]">• {col.categoria}</span></div>
                <div className="flex flex-wrap gap-3 mt-1 text-xs text-[#425a62]">
                  {col.cidade && <span className="flex items-center gap-1"><MapPin className="w-3 h-3 text-[#075a6d]" /> {col.cidade}</span>}
                  {col.contato && <span className="flex items-center gap-1"><Phone className="w-3 h-3 text-[#075a6d]" /> {col.contato} ({col.canal})</span>}
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3 text-[#075a6d]" /> {new Date(c.createdAt).toLocaleString('pt-BR')}</span>
                </div>
              </div>
              {urgent && <span className="inline-flex items-center gap-1 bg-red-50 text-red-700 border border-red-200 rounded-full px-2.5 py-0.5 text-xs font-semibold"><AlertTriangle className="w-3 h-3" /> Urgente</span>}
            </div>
            {c.summary && <p className="text-sm text-[#354c54] mt-3 bg-[#f7fafb] rounded-[7px] p-3 whitespace-pre-line">{c.summary}</p>}
            <div className="mt-2 text-[11px] text-[#6b858e]">Consentimento registrado • Origem: Recepcionista IA • Contato criado no CRM automaticamente</div>
          </div>
        );
      })}
    </div>
  );
};
